import {
  AccountVerificationStatus,
  IAccount
} from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountVerificationPending = (account: IAccount) =>
  account.accountVerification?.status === AccountVerificationStatus.Requested ||
  account.accountVerification?.status === AccountVerificationStatus.Pending;
